<template>
  <div class="filter-popup">
    <h1 v-if="title !== ''">{{ title }}</h1>
     <div>
      <p>Match: {{ getTotalMatch() }}</p>
    </div>
    <div class="search-row">
      <el-row :gutter="20">
        <div class="align-search">
          <div class="fake-input">
            <el-tag
              class="horizontal-space"
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :size="'medium'"
              :disable-transitions="false"
              @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-autocomplete
              class="inline-input horizontal-space"
              size="mini"
              v-model="searchUserInput"
              :fetch-suggestions="querySearch"
              placeholder="Please Input"
              @select="addValueToKey"
            ></el-autocomplete>
          </div>
          <div style="margin-top: 12px">
            <el-button class="horizontal-space" color="primary" type="border" @click="setFilterForDatas">Recherche</el-button>
            <el-button class="horizontal-space" color="primary" type="border" @click="clearAllTags">Effacer</el-button>
            <el-tooltip class="item" effect="dark" content="Ajouter cette recherche aux favoris" placement="top">
            <el-button type="warning" icon="el-icon-star-off" @click="dialogFormVisible = true" circle></el-button>
            </el-tooltip>
          </div>
        </div>
      </el-row>
      <el-dialog 
        title="Ajouter la requête aux favoris" 
        :visible.sync="dialogFormVisible"
        :modalAppendToBody="false">
        <el-input
          class="search-row"
          type="text" 
          v-model="favorite.name"
          placeholder="Nom"
        ></el-input>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Description"
          v-model="favorite.description">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Annuler</el-button>
          <el-button type="primary" @click="recordToFavorites">Enregistrer</el-button>
        </span>
      </el-dialog>
    </div>
    <el-collapse>
      <el-collapse-item name="1">
        <template slot="title">
          <span><i class="el-icon-s-unfold icon-left"></i> Tags</span>
        </template>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <span><i class="el-icon-star-off icon-left"></i> Favorites</span>
        </template>
        <ul>
          <li v-for="(fav, idx) in favoriteList" :key="idx" @click="setFilterTo(fav.value)"><strong>{{ fav.name }} :</strong> {{ fav.description }} | {{ fav.value }}</li>
        </ul>
      </el-collapse-item>
    </el-collapse>

    <!-- Info for dev env only ********************************************************* -->
    <div v-if="mode === 'dev'" style="margin: 20px; padding: 20px; border: solid;">
      <h3>DEV MODE ONLY</h3>
      <p>queryAsString : {{ queryAsString }}</p>
      <p>autocompleteKeyValue: {{ autocompleteKeyValue }}</p>
      <ul>
        <li v-for="(elmt, idx) in keyList" :key="idx">{{ elmt }}</li>
      </ul>
      <div>
        <ul>
          <li v-for="(item, idx) in collection" :key="idx">{{ item }}</li>
        </ul>
      </div>
      <div>
        <ul>
          <li v-for="(item, idx) in filteredCollection" :key="idx">{{ item }}</li>
        </ul>
      </div>
    </div>
    <!-- Info for dev env only ********************************************************* -->
  </div>
</template>

<script>
export default {
  props: {
    collection: {
      type: Array,
      required: true
    }, 
    model: {
      type: Array,
    },
    mode: {
      type: String,
      default: 'dev'
    },
    title: {
      type: String,
      default: ''
    },
    setQuery: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      keyList : [],
      valueList: [],
      searchUserInput: '',
      autocompleteKeyValue: 'key',
      keyRef: '',
      queryAsString: '',
      dynamicTags: [],
      filteredCollection: [],
      favoriteList: [],
      favorite: {name: '', description: '', tagList: []},
      //---------------------
      querySplited: [],
      dialogFormVisible: false,
    }
  },
  created() {
    this.initTagValue(this.collection);
    this.$emit('filteredData', this.collection);
    const savedFavorites = JSON.parse(localStorage.getItem('filterFavorites'))
    if(savedFavorites) {
      this.favoriteList = savedFavorites;
    }
  },
  computed: {
  },
  watch: {
    collection(n) {
      console.log('WATCH collection: ', n);
      this.initTagValue(n);
      console.log('LOCAL STORAGE: ', JSON.parse(localStorage.getItem('filterFavorites')));
      this.favoriteList = JSON.parse(localStorage.getItem('filterFavorites'));
    },
    searchUserInput(n) {
      //-- Switch key / value
      console.log('n: ', n);
      if (n !== undefined && n.length > 0 && n.indexOf(':') > 0) {
        this.autocompleteKeyValue = 'value';
        this.keyRef = this.searchUserInput.split(':')[0]
      } else  {
        this.autocompleteKeyValue = 'key';
      }
      //-- Switch key on blank input
      if (n !== undefined && n === '') {
        this.autocompleteKeyValue = 'key';
        this.keyRef = '';
      }
    },
    dynamicTags(n) {
      console.log('dynamicTags watched: ', this.dynamicTags);
      this.filteredCollection = this.getFilteredDatas(this.collection, this.tagSplitter(n));
      if( this.setQuery !== undefined) {
        this.$emit('filteredData', this.filteredCollection);
      }
    },
    setQuery(n) {
      if(n !== undefined && n.value !== undefined) {
        this.setFilterTo(n.value);
        return;
      }
      this.clearAllTags();
      this.$emit('filteredData', this.collection);
    }
  },
  methods: {
    generateSearchFilterFormat: function(coll, model = []) {
      //- 1 - CREATE KEY LIST
      let keyList = [];
      if( model.length > 0) {
        model.forEach( k => keyList.push({value: k}))
      } else {
        let allKeys = []
        coll.forEach( dt => {
          const objectKeyList = Object.keys(dt);
          objectKeyList.forEach( k => allKeys.push(k));
        })
        allKeys = Array.from(new Set(allKeys));
        allKeys.forEach( k => keyList.push({value: k}));
      }
      //- 2 - CREATE VALUES LIST
      const valueListByKey = {};
      keyList.forEach( k => {
        let valuesAvailable = new Set();
        let tagList = [];
        coll.forEach( item => {
          if( (k.value === 'tag' || k.value === 'tags') && (item.tag !== undefined || item.tags !== undefined)) {
            tagList = Array.from(new Set([...tagList, ...item[k.value]]));
          } else {
            valuesAvailable.add(item[k.value]);
          }
        });
        if( k.value === 'tag' || k.value === 'tags') {
          valuesAvailable = new Set(tagList);
        }
        let tempList = [];
        valuesAvailable.forEach( val => tempList.push( {value: val}));
        valueListByKey[k.value] = tempList ;
      })
      //- RETURN 
      console.log('keyList: ', keyList);
      console.log('valueListByKey: ', valueListByKey);
      return {keyList: keyList, valueListByKey: valueListByKey};
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    setFilterForDatas: function() {
      this.queryAsString = this.queryAsString[this.queryAsString.length - 1] === ',' ? this.queryAsString.slice(0, -1) : this.queryAsString;
      this.$emit('filteredData', this.filteredCollection);
    },
    addValueToKey(value) {
      console.log('Add value to key : ', value);
      if( this.autocompleteKeyValue === 'value') {
        let newTag = `${this.keyRef}:${this.searchUserInput}`;
        if (newTag) {
          this.dynamicTags.push(newTag);
        }
        this.queryAsString += `${newTag},`;
        this.searchUserInput = '';
      } else {
        this.searchUserInput += ':';
      }
    },
    setFilterTo(favfilter) {
      this.dynamicTags = favfilter;
    },
    initTagValue: function(coll) {
      console.log('initTagValue coll: ', coll);
      const analyzedData = this.generateSearchFilterFormat(coll, this.model);
      this.keyList = analyzedData.keyList;
      this.valueList = analyzedData.valueListByKey;
      this.filteredCollection = this.collection;
    },
    tagSplitter: function(tagList) {
      let filterFormat = [];
      tagList.forEach( tag => {
        let kv = tag.split(':');
        filterFormat.push({ [kv[0]]: kv[1] })
      })
      return filterFormat;
    },
    getFilteredDatas: (coll, searchTerms) => {
      let filtered = coll.filter( data => {
        let condition = true;
        searchTerms.forEach( search => {
          if (condition) {
            const key = Object.keys(search)[0];
            let value = search[key];
            if(value === "true") {
              value = true;
            } else if (value === "false"){
              value = false;
            } 
            if( (key === 'tag' || key === 'tags') && data[key] !== undefined) {
              condition = (data[key].includes(String(value)));
            } else {
              condition = (data[key] === value);
            }
          }
        })
        return condition;
      });
      const sorted = filtered.sort( x => x.datas !== undefined && x.datas[x.datas.length - 1].errorType !== 'no error' ? -1: 1);
      return sorted;
    },
    getTotalMatch() {
      return `${this.filteredCollection.length} / ${this.collection.length}`
    },
    recordToFavorites: function() {
      //-- Save in ddb then if res === 200
      this.favoriteList.push({name: this.favorite.name, description: this.favorite.description, value: this.dynamicTags});
      this.$notify({
        title: 'Opération validée',
        message: 'Recherche Enregistrée dans les favoris',
        type: 'success'
      });
      localStorage.setItem('filterFavorites', JSON.stringify(this.favoriteList));
      this.favorite.name = '';
      this.favorite.description = '';
      this.dialogFormVisible = false;
    },
    querySearch(queryString, cb) {
      console.log('this.valueList[this.keyRef] : ', this.valueList[this.keyRef]);
      if(queryString.indexOf(':') > 0) {
        queryString = queryString.split(':')[1];
      }
      let keyList = this.autocompleteKeyValue === 'key' ? this.keyList : this.valueList[this.keyRef];
      let results = queryString ? keyList.filter(this.createFilter(queryString)) : keyList;
      cb(results);
    },
    createFilter(queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    clearAllTags() {
      this.dynamicTags = [];
    },
    logInfo(){
      console.log('this.generateSearchFilterFormat: ', this.generateSearchFilterFormat(this.collection, this.model));
    }
  }
}
</script>

<style scoped>
  li {
    list-style-type: none;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    border-bottom: solid rgba(0, 0, 0, 0.2) 1px;
    color: rgba(0, 0, 0, 0.3);
    padding: 6px;
  }

  li:hover {
    background-color: rgba(173, 216, 230, 0.3);
    cursor: pointer;
    color: rgba(0, 0, 0, 0.8);
  }

  .search-input {
    width: 100%;
    font-size: 14px;
    padding: 5px;
    margin-right: 12px;
  }

  .filter-popup {
    margin: 50px;
  }

  .flex-position {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  } 

  .suggestion-list {
    margin: 12px 0 24px 0;
    max-height: 150px;
    overflow-y: auto;
  }

  .btn-width {
    width: 500px;
  }

  .top {
    text-align: center;
  }

  .search-row {
    margin-bottom: 20px;
  }

  .icon-left {
    margin-left: 12px;
  }

  .horizontal-space {
    margin-left: 6px;
  }
  .fake-input {
    margin-top: 12px;
    display: flex;
    align-items: center;
    width: 70%;
    height: 40px;
    border: 1px solid lightgray;
    border-radius: 4px;
  }

  .align-search {
    display: flex;
  }
</style>
